import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import NavbarUni from './componentes/headUni';
import { Container, Row, Col } from "react-bootstrap";
import { Truck, CreditCard, ShieldLock, ArrowDownShort } from "react-bootstrap-icons";
import FooterPublic from './FooterPublic';

const PreguntasFrecuentes = () => {
    return (
        <div style={{ paddingTop: '80px' }}>
            <NavbarUni />
            <div className="position-relative text-center d-inline-block w-100">
                <img
                    src="https://reymidascaps.s3.us-east-2.amazonaws.com/utils/gorrabackgroun.webp"
                    alt="Preguntas Frecuentes"
                    className="img-fluid w-100"
                    loading='lazy'
                    style={{ height: '30vh', objectFit: 'cover' }} // Controla altura y mantiene proporción
                />
                <div
                    className="position-absolute top-50 fs-2 fw-bold text-white text-uppercase"
                    style={{
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textShadow: '2px 2px 8px rgba(0, 0, 0, 0.7)',
                    }}
                >
                    PREGUNTAS FRECUENTES
                </div>
            </div>
            <Container className='my-5'>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                    Preguntas Frecuentes
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="text.primary" sx={{ mb: 4 }}>
                    ¿Tienes alguna pregunta? ¡Aquí te ayudamos!
                </Typography>

                <Row className="text-center gy-4 my-5 my-md-5">
                    {/* Envíos Gratis */}
                    <Col xs={12} sm={6} md={4} className="d-flex align-items-center justify-content-center">
                        <Truck size={30} className="me-3 text-black" />
                        <div>
                            <h6 className="fw-bold mb-1">ENVÍOS GRATIS</h6>
                            <p className="mb-0 text-muted">A todo Colombia</p>
                        </div>
                    </Col>

                    {/* Pagá como quieras */}
                    <Col xs={12} sm={6} md={4} className="d-flex align-items-center justify-content-center">
                        <CreditCard size={30} className="me-3 text-black" />
                        <div>
                            <h6 className="fw-bold mb-1">PAGÁ COMO QUIERAS</h6>
                            <p className="mb-0 text-muted">PSE, Efecty, Baloto y más</p>
                        </div>
                    </Col>

                    {/* Compra con seguridad */}
                    <Col xs={12} sm={6} md={4} className="d-flex align-items-center justify-content-center">
                        <ShieldLock size={30} className="me-3 text-black" />
                        <div>
                            <h6 className="fw-bold mb-1">COMPRA CON SEGURIDAD</h6>
                            <p className="mb-0 text-muted">Tus datos siempre protegidos</p>
                        </div>
                    </Col>
                </Row>

                {/* Acordeón */}
                <Accordion>
                    <AccordionSummary expandIcon={<ArrowDownShort />} aria-controls="panel1-content" id="panel1-header">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            ¿Manejan pago contra entrega?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Sí, solo pedimos el pago del costo de envío por adelantado. El resto lo paga en casa al recibir su pedido.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ArrowDownShort />} aria-controls="panel2-content" id="panel2-header">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            ¿Cuánto cuesta el envío con pago contra entrega?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Puede cotizar el costo del envío ingresando a nuestro catálogo y seleccionando su pedido.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ArrowDownShort />} aria-controls="panel3-content" id="panel3-header">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            ¿Dónde están ubicados?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Nuestra bodega está en Pasto, Nariño, pero realizamos envíos a toda Colombia.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ArrowDownShort />} aria-controls="panel4-content" id="panel4-header">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            ¿Cuál es la dirección de la bodega?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Estamos en Pasto, Nariño. Todos los pedidos se deben hacer a través del catálogo y los enviamos a domicilio.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ArrowDownShort />} aria-controls="panel5-content" id="panel5-header">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            ¿Por qué confiar en nosotros?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Tenemos más de 5,000 gorras en stock. Antes de cualquier pago, enviamos fotos o videos de su pedido para que verifique los modelos antes de la compra.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Container>
            <FooterPublic />
        </div>
    );
};

export default PreguntasFrecuentes;
